import "./TaskDialog.scss";
import { IModalService, IModalSettings } from "angular-ui-bootstrap";
import { TaskDialogController } from "./WorkflowTaskComponent";
import { AccountId } from "app/account/types/AccountRecord";
import { WorkflowTask } from "./WorkflowTaskComponent";
import { WorkflowRecord } from "../models/WorkflowRecord";
import { WorkflowViewStore } from "../store/WorkflowViewStore";


export class WorkflowTaskService {

  public static id = "workflowTaskService";

  /** @ngInject */
  public constructor(private readonly $uibModal: IModalService) {
  }

  public async open(): Promise<void> {
    const instance = this.$uibModal.open({
      templateUrl: "app/account/components/workflow/wizard/TaskDialog.html",
      backdrop: "static",
      size: "xl",
      windowClass: "workflow-task-dialog",
      controller: TaskDialogController,
      controllerAs: "ctrl"
    });
    return instance.result;
  }

  public async openEdit(_store: WorkflowViewStore, accountId: AccountId, workflow?: WorkflowRecord): Promise<WorkflowRecord> {
    const modalConfig: IModalSettings = {
      component: WorkflowTask,
      backdrop: "static",
      size: "lg",
      resolve: {
        accountId: () => accountId,
        workflow: () => workflow,
        _store: () => _store,
      }
    };
    const instance = this.$uibModal.open(modalConfig);
    return instance.result;
  }

}